import { BasePaginationRequest } from 'modules/pond/api/types'
import { GetPrecursorStockParams } from 'modules/warehouse/reactant/api/types'
import { GetVitaminsParams } from 'modules/warehouse/vitamin/api/types'
import { GetVitaminCycleHistoryParams } from 'modules/warehouse/vitaminCycle/api/types'
import { GetVitaminsRequestsParams } from 'modules/warehouse/withdrawVitamin/api/types'

export const USER_INFO_KEY = ['user']
export const FARMS_KEY = ['farms']
export const MANAGERS_KEY = ['managers']
export const REQUESTED_EMPLOYEE_KEY = ['requested-employee']
export const EMPLOYEES_KEY = ['employees']
export const getPondsKey = (farmId?: string) => ['ponds', farmId]
// Nested under getPondsKey so a future invalidation of the pond list refreshes the row too.
export const getFarmOverviewKey = (
  farmId?: string,
  minAge?: number | null,
  maxAge?: number | null
) => [...getPondsKey(farmId), 'overview', minAge ?? null, maxAge ?? null]
export const POND_CARETAKERS = ['pond-caretakers']
export const POND_TYPES_KEY = ['pond-types']
export const FOOD_BRANDS_KEY = ['food-brands']
export const SHRIMP_BRANDS_KEY = ['shrimp-brands']
export const getShrimpTypesKey = (brand: number) => ['shrimp-types', brand]
export const getCycleKey = (cycleId: string) => ['cycle', cycleId]
export const getCyclesKey = (pondId?: string) => ['cycles', pondId]
export const getMealsKey = (date: string, cycleId: string) => ['meals', date, cycleId]
export const FOOD_SIZES_KEY = ['food-sizes']
export const FEEDING_TYPES_KEY = ['feeding-types']
export const getFoodLineChartKey = (cycleId: string, period?: string) => [
  'food-line-chart',
  cycleId,
  period,
]
export const getFoodStandardLineChartKey = (cycleId: string, period?: string) => [
  'food-standard-line-chart',
  cycleId,
  period,
]
export const getFoodSummaryKey = (cycleId: string, date?: string) => ['food-summary', cycleId, date]
export const getFoodsKey = ({
  cycleId,
  date,
  feedingType,
}: {
  cycleId: string
  date?: Date
  feedingType?: number
}) => ['foods', cycleId, date, feedingType]
export const getWaterQualitiesKey = (cycleId: string, date?: Date | string) => [
  'water-quality',
  cycleId,
  date,
]
export const getWaterMineralsKey = (cycleId: string, date?: Date | string) => [
  'water-mineral',
  cycleId,
  date,
]
export const getWaterBacteriasKey = (cycleId: string, date?: Date | string) => [
  'water-bacteria',
  cycleId,
  date,
]
export const getWaterQualityChartKey = (cycleId: string) => ['water-quality-chart', cycleId]
export const getWaterMineralChartKey = (cycleId: string) => ['water-mineral-chart', cycleId]
export const getWaterBacteriaChartKey = (cycleId: string) => ['water-bacteria-chart', cycleId]
export const getDeadShrimpsKey = (cycleId: string, date?: Date | string) => [
  'dead-shrimp',
  cycleId,
  date,
]
export const getDeadShrimpChartKey = (cycleId: string) => ['dead-shrimp-chart', cycleId]
export const getGrowthShrimpChartKey = (cycleId: string) => ['growth-shrimp-chart', cycleId]
export const getGrowthShrimpsKey = (cycleId: string, date?: Date | string) => [
  'growth-shrimps',
  cycleId,
  date,
]
export const getGrowthStandardLineChartKey = (cycleId: string) => [
  'food-growth-line-chart',
  cycleId,
]
export const getMedicinesKey = (cycleId: string, date?: Date | string) => [
  'medicines',
  cycleId,
  date,
]
export const getLatestMedicinePriceKey = (name: string) => ['medicine-price', name]
export const getMedicineNameKey = (farmId: string) => ['medicine-names', farmId]
export const getMedicinePieChartkey = (cycleId: string) => ['medicine-pie-chart', cycleId]
export const getLatestFoodPriceKey = (cycleId: string, foodSizeId: number | null) => [
  'food-price',
  cycleId,
  foodSizeId,
]
export const getPondDashboardKey = (pondId: string, cycleId: string) => [
  'pond-dashboard',
  pondId,
  cycleId,
]
export const getPondInfoKey = (cycleId: string) => ['pond-info', cycleId]
export const getCycleSummaryKey = (cycleId: string) => ['cycle-summary', cycleId]
export const getPondDashboardTableKey = (cycleId: string, request: BasePaginationRequest) => [
  'pond-dashboard-table',
  cycleId,
  request,
]
export const getShrimpSalesKey = (cycleId: string, date: Date | undefined) => [
  'shrimpSales',
  cycleId,
  date,
]
export const getCostKey = (cycleId: string | null) => ['cost', cycleId]
export const UNIT = ['unit']
export const AREA_UNIT = ['areaUnit']
export const getShrimpSalesSummaryKey = (cycleId: string) => ['getShrimpSalesSummaryKey', cycleId]
export const getFoodBrandsKey = (speciesId?: number) => ['food-brands', speciesId]
export const LATEST_FOOD_BRAND = ['latest-food-brand']
export const LATEST_FOOD_SIZE = ['latest-food-size']
export const getFoodSizeKey = (foodBrandId: number, proteinId: number, breedId?: number) => [
  'food-size',
  foodBrandId,
  proteinId,
  breedId,
]
export const getShrimpPriceKey = (startDate: string, endDate: string, regionId: number | null) => [
  'shrimp-price',
  startDate,
  endDate,
  regionId,
]
export const SPECIES_KEY = ['species']
export const getSpeciesIdKey = (speciesId: number) => ['speciesId', speciesId]
export const getBreedKey = (speciesId: number) => ['breed', speciesId]
export const getBreedBrandKey = (breedId: number) => ['breed-brand', breedId]
export const getBreedProductKey = (breedId: number, speciesId: number) => [
  'breed-product',
  breedId,
  speciesId,
]
export const getBreedNameKey = (speciesId: number, breedId: number) => [
  'breedName',
  speciesId,
  breedId,
]
export const getFeedProgramIdKey = (feedProgramId: number) => ['feedProgramId', feedProgramId]
export const getDiseaseKey = (speciesId?: number) => ['shrimp-diseases', speciesId]
export const getProteinKey = (foodbrandId: number, speciesId: number) => [
  'protein',
  foodbrandId,
  speciesId,
]
export const getRecentFoodKey = (cycleId: string) => ['recent-food', cycleId]
export const getRecentMedicineKey = (cycleId: string) => ['recent-medicine', cycleId]
export const getMarketIdKey = (marketId: number) => ['marketId', marketId]

export const getMemberIdkey = (userId: number) => ['userId', userId]

export const getMembersKey = (userId?: string, search = '') => ['members', userId, search]
export const getRolesKey = (userId?: string) => ['roles', userId]
export const getPresetKey = (userId?: string) => ['preset', userId]
export const getFeaturesKey = (userId?: string) => ['features', userId]
export const getFarmGroupKey = (search: string) => ['farmGroup', search]

export const getCategoryIdKey = (category: string) => ['category', category]
export const getPondMediaKey = (pondId: string, date: string, sort: string, tag: string) => [
  'pond-media',
  pondId,
  date,
  sort,
  tag,
]

export const PRECURSOR_SUMMARY_KEY = ['precursor-summary']
export const getPrecursorStockKey = (params?: GetPrecursorStockParams) => ['PrecursorStock', params]
export const PRECURSOR_KEY = ['precursor-list']

export const VITAMINS_SUMMARY_KEY = ['vitamin-summary']
export const getVitaminsStockKey = (params?: GetVitaminsParams) => ['VitaminsStock', params]
export const VITAMINS_KEY = ['vitamins']

export const VITAMIN_FARM_KEY = ['vitamin-farm']
export const getVitaminFarmWithdrawalSummaryInfiniteKey = () => [
  'VitaminFarmWithdrawalSummaryInfinite',
]
export const getPrecursorSummaryInfiniteKey = () => ['PrecursorSummaryInfinite']
export const getVitaminsSummaryInfiniteKey = () => ['VitaminsSummaryInfinite']
export const VITAMIN_PERIOD_KEY = ['vitamin-period']
export const VITAMIN_CYCLE_CURRENT_KEY = ['vitamin-cycle-current']
export const getVitaminCycleHistoryKey = (params?: GetVitaminCycleHistoryParams) => [
  'vitamin-cycle-history',
  params,
]
export const getVitaminsRequestsKey = (params?: GetVitaminsRequestsParams) => [
  'VitaminsRequests',
  params,
]
export const getVitaminsPlanKey = (planId?: number) => ['vitamin-plan', planId]

export const ALL_DROPDOWN_KEY = ['all-dropdown']
export const getDataDropdownByTypeKey = (type?: string) => ['data-dropdown-by-type', type]

export const FARM_NOTIFICATIONS_KEY = ['farm-notifications']
export const getNotificationKey = (farmId: string, page: number) => ['notifications', farmId, page]
export const TOTAL_UNREAD_NOTIFICATION = ['total-unread-notification']

export const WATER_QUALITY_THRESHOLD_KEY = ['water-quality-threshold']
export const MEAL_THRESHOLD_KEY = ['meal-threshold']
export const SHRIMP_HEALTH_THRESHOLD_KEY = ['shrimp-health-threshold']

export const SHRIMP_SALES_PARTIAL = ['shrimp-sales-partial']
export const SHRIMP_SALES_CATEGORY = ['shrimp-sales-category']
export const getShrimpSalesPartialByIdKey = (id: string) => ['shrimp-sales-partial', id]

export const PARTIAL_TRANSFER = ['partial-transfer']
export const getPartialDateListKey = (cycleId: string) => ['partial-date-list', cycleId]
export const getPartialTransferByCycleKey = (cycleId: string) => [
  'partial-transfer-by-cycle',
  cycleId,
]

export const getDiseaseDashboardLabTableKey = (farmId: string, request: BasePaginationRequest) => [
  'disease-lab-table',
  farmId,
  request,
]

export const getShrimpSizeTableKey = (farmId: string, request: BasePaginationRequest) => [
  'shrimp-size-table',
  farmId,
  request,
]

export const getOrganizationProductionKey = (
  farmIds?: string[],
  minSize?: number,
  maxSize?: number
) => ['organization-production', farmIds, minSize, maxSize]
export const getOrganizationSurvivalKey = (farmIds?: string[]) => ['organization-survival', farmIds]
export const getOrganizationADGKey = (farmIds?: string[]) => ['organization-adg', farmIds]
export const getOrganizationPDGKey = (farmIds?: string[]) => ['organization-pdg', farmIds]
export const getOrganizationSizeForecastKey = (farmIds?: string[]) => [
  'organization-size-forecast',
  farmIds,
]
export const getOrganizationFeedBrandKey = (
  farmIds: string[] | undefined,
  startDate: string,
  endDate: string
) => ['organization-feed-brand', farmIds, startDate, endDate]
export const getOrganizationOverviewStatsKey = (farmIds?: string[]) => [
  'organization-overview-stats',
  farmIds,
]
